const moment = require("moment-timezone");

module.exports = (date) => {
  const userTimezone = moment.tz.guess(); // e.g., "America/Los_Angeles"

  const formatted = moment
    .tz(date, userTimezone)
    .format("ddd MMMM D YYYY [@] hA");
  // const m = moment(date);
  // let d = new Date(date);
  // let dateString = d.toDateString();
  // let hours = d.getHours();
  // let minutes = d.getMinutes();

  // let timeString;
  // if (hours > 12 && minutes === 0) {
  //   timeString = `${hours - 12} PM`
  // } else if (hours > 12 && minutes > 0){
  //   timeString = `${hours - 12}:${minutes} PM`
  // } else if (hours <= 12 && minutes === 0) {
  //   timeString = `${hours} AM`
  // } else if (hours <= 12 && minutes > 0) {
  //   timeString = `${hours}:${minutes} AM`
  // }

  // return `${dateString} @ ${timeString}`
  return formatted;
};
